/**
 * api接口统一管理
 */

import { get, post, put, dele, upload, download } from '@/utils/request_z'
import { changeOption } from '@/utils'
// const HttpType = { get, post, put, upload, download }

// export default HttpType


/**
 * 将对象转换成数组
 * @param {object} res 转换的对象
 * @param {boolean} isKey value是否是key 默认 false
 * @returns {BaseInterface['option'][]}
 */
export const changeObjToArr = (res, isKey = false) => {
  if (!res) return []
  if (typeof res !== 'object') {
    return []
  }
  if (Array.isArray(res)) {
    return res.map((item, idx) => ({ value: isKey ? idx : item, label: item }))
  }
  return Object.keys(res).map(key => {
    return { value: isKey ? Number(key) : res[key], label: res[key] }
  })
}



// 表格数据
export const tableList = (apiUrl, params) => new Promise((resolve, reject) => get(apiUrl, params).then(res => {
  const { list, page } = res
  let config = { total: 0, pageCount: 0, list: [] }
  if (list) {
    config = { total: page.total, pageCount: page.last_page, list }
  }
  resolve(config)
}).catch(err => reject(err)))


/**
 * @typedef {Object} BaseInterface
 * @property {'video_article_basic' | 'video_article_config' | 'video_knowledge_basic' | 'video_category', 'time_course_basic'} zh_history_type 类型名称
 * @property {'goods' | 'goods_standard' | 'goods_pack_name' | 'account_data' | 'examination' | 'graduation_school' | 'subject' | 'score_line' | 'account' | 'order_fresh_graduate' | 'direct_student' | 'exam_2024'} zs_history_type 类型名称
 * @property {{label:string, value:string|number}} option 字符串数组
 */

const fw = '/voluntary'
const zh = '/wisdom-education'
const zs = '/zhaosheng/api'
const api1 = '/api1'
const api2 = '/api2/api'
const api3 = '/api3/api'
const api4 = '/api4'

const apiMap = { fw, zh, zs, api1, api2, api3, api4 }

const http = (custom = {}, data = {}, config = {}) => new Promise((resolve, reject) => {
  const { url, method, pre } = custom
  if (!url) return reject('url不能为空')
  const types = ['get', 'post', 'put', 'delete']
  if (!types.includes(method)) return reject('请求类型错误')
  const prefixMap = Object.keys(apiMap)
  if (pre && !prefixMap.includes(pre)) return reject('请求前缀错误')
  const prefix = pre ? apiMap[pre] : ''
  if (method === 'get') {
    return get(`${prefix}${url}`, data, config).then(res => resolve(res)).catch(err => reject(err))
  } else if (method === 'post') {
    return post(`${prefix}${url}`, data, config).then(res => resolve(res)).catch(err => reject(err))
  } else if (method === 'put') {
    return put(`${prefix}${url}`, data, config).then(res => resolve(res)).catch(err => reject(err))
  } else if (method === 'delete') {
    return dele(`${prefix}${url}`, data, config).then(res => resolve(res)).catch(err => reject(err))
  }
})
const changeCustom = (custom, data = {}, config = {}, type) => {
  let url = '', pre = '';
  let newType = type || 'get'
  if (typeof custom === 'string') {
    url = custom
  } else {
    url = custom.url
    if (!type && custom.method) newType = custom.method
    if (custom.pre) pre = custom.pre
  }
  return http({ method: newType, url, pre }, data, config)
}
/**
 * @function 设置统一api接口方法
 * @param {object|string} custom 自定义参数 string/object
 * @param {string} custom.url 请求地址data 请求参数
 * @param {'get'|'post'|'put'} custom.method 请求类型
 * @param {string} custom.pre 请求前缀
 * @param {object} data 请求参数
 * @param {object} config 配置参数
 * @returns
 */

const baseApi = (custom, data = {}, config = {}) => changeCustom(custom, data, config)
/**
 * @function api.get
 * @param {object|string} custom 自定义参数
 * @param {object} data 请求参数
 * @param {object} config 配置参数
 * @returns
 */
baseApi.get = (custom, data = {}, config = {}) =>  changeCustom(custom, data, config, 'get')
/**
 * @function api.search
 * @param {object|string} custom 自定义参数
 * @param {object} data 请求参数
 * @param {object} config 配置参数
 * @returns
 */
baseApi.search = (custom, data = {}, config = {}) => new Promise((resolve, reject) => {
  changeCustom(custom, data, config, 'get').then(res => {
    const list = res || []
    resolve(list)
  }).catch(err => reject(err))
})
/**
 * @function api.post
 * @param {object|string} custom 自定义参数
 * @param {object} data 请求参数
 * @param {object} config 配置参数
 * @returns
 */
baseApi.post = (custom, data = {}, config = {}) => changeCustom(custom, data, config, 'post')
/**
 * @function api.put
 * @param {object|string} custom 自定义参数
 * @param {object} data 请求参数
 * @param {object} config 配置参数
 * @returns
 */
baseApi.put = (custom, data = {}, config = {}) => changeCustom(custom, data, config, 'put')
/**
 * @function api.delete
 * @param {object|string} custom 自定义参数
 * @param {object} data 请求参数
 * @param {object} config 配置参数
 * @returns
 */
baseApi.delete = (custom, data = {}, config = {}) => changeCustom(custom, data, config, 'delete')

export default baseApi
export { baseApi }
/**
 * 设置统一智慧教育接口方法
 */
/**
 * @function 智慧教育/wisdom-education
 * @param {string} api 请求地址
 * @param {object} params 请求参数
 * @param {object} config 配置参数
 * @returns
 */
export const zhGet = (api, params = {}, config = {}) => get(`${zh}${api}`, params, config)
/**
 * @function 智慧教育/wisdom-education
 * @param {string} api 请求地址
 * @param {object} data 更改参数
 * @param {object} config 配置参数
 * @returns
 */
export const zhPut = (api, data = {}, config = {}) => put(`${zh}${api}`, data, config)
/**
 * @function 智慧教育/wisdom-education
 * @param {string} api 请求地址
 * @param {object} data 保存参数
 * @param {object} config 配置参数
 * @returns
 */
export const zhPost = (api, data = {}, config = {}) => post(`${zh}${api}`, data, config)

/**
 * 设置统一招生接口方法
 */
/**
 * @function 招生/zhaosheng/api
 * @param {string} api 请求地址
 * @param {object} params 请求参数
 * @param {object} config 配置参数
 * @returns
 */
export const zsGet = (api, data = {}, config = {}) => get(`${zs}${api}`, data, config)
/**
 * @function 招生/zhaosheng/api
 * @param {string} api 请求地址
 * @param {object} data 更改参数
 * @param {object} config 配置参数
 * @returns
 */
export const zsPut = (api, data = {}, config = {}) => put(`${zs}${api}`, data, config)
/**
 * @function 招生/zhaosheng/api
 * @param {string} api 请求地址
 * @param {object} data 保存参数
 * @param {object} config 配置参数
 * @returns
 */
export const zsPost = (api, data = {}, config = {}) => post(`${zs}${api}`, data, config)

/**
 * 设置统一api2接口方法
 */
/**
 * @function /api2/api
 * @param {string} api 请求地址
 * @param {object} params 请求参数
 * @param {object} config 配置参数
 * @returns
 */
export const getApi2 = (api, data = {}, config = {}) => get(`${api2}${api}`, data, config)
/**
 * @function /api2/api
 * @param {string} api 请求地址
 * @param {object} data 更改参数
 * @param {object} config 配置参数
 * @returns
 */
export const putApi2 = (api, data = {}, config = {}) => put(`${api2}${api}`, data, config)
/**
 * @function /api2/api
 * @param {string} api 请求地址
 * @param {object} data 保存参数
 * @param {object} config 配置参数
 * @returns
 */
export const postApi2 = (api, data = {}, config = {}) => post(`${api2}${api}`, data, config)


/**
 * @function 上传模板文件
 * @param {string} api 请求地址
 * @param {object?} formData 上传参数
 * @param {object?} config 配置参数
 * @returns
 */
export const fileUpload = (api, formData = {}, config = {}) => upload(api, formData, config)

/**
 * @function 下载文件
 * @param {string} api 请求地址
 * @param {object?} params 请求参数
 * @param {object?} config 配置参数
 * @returns
 */
export const fileDownload = (api, params = {timeout: 0}, config = {}) => download(api, params, config)


/**
 * @function 上传文件 检查文件是否存在
 * @param {object} params 请求参数
 * @param {string} params.file_hash 请求参数
 * @param {object} config 配置参数
 * @returns
 */
export const fileCheck = (params = {}, config = {}) => get(`${api2}/upload/check`, params, config)
/**
 * @function 上传文件 分片上传初始化
 * @param {object} data 上传参数
 * @param {string} data.file_name 文件名
 * @param {string} data.file_hash 文件hash值
 * @param {string} data.extension 文件格式
 * @param {string} data.file_size 文件大小
 * @param {string} data.mime_type 文件mime类型
 * @param {object} config 配置参数
 * @returns {object} {file_upload_id: 文件上传id, file_name: 文件名}
 */
export const fileInit = (data = {}, config = {}) => post(`${api2}/upload/init`, data, config)
/**
 * @function 上传文件 分片上传分割文件
 * @param {object} formData 上传参数
 * @param {string} formData.file 上传文件
 * @param {string} formData.file_name 文件名
 * @param {string} formData.extension 文件格式
 * @param {string} formData.file_upload_id 文件上传id
 * @param {string} formData.part_number 文件分片值
 * @param {object} config 配置参数
 * @returns
 */
export const fileChunk = (formData = {}, config = {}) => upload(`${api2}/upload/chunk`, formData, config)
/**
 * @function 上传文件 完成分片长传文件合并
 * @param {object} data 上传参数
 * @param {string} data.file_name 文件名
 * @param {string} data.extension 文件格式
 * @param {string} data.file_upload_id 文件上传id
 * @param {string} data.parts
 * @param {object} config 配置参数
 * @returns
 */
export const fileComplete = (data = {}, config = {}) => post(`${api2}/upload/complete`, data, config)

/**
 * @function 文件上传2
 * @param {object?} formData 上传参数
 * @param {object?} config 配置参数
 * @returns
 */
export const fileUploadV2 = (formData = {}, config = {}) => upload(`${api2}/upload/upload-v2`, formData, config)
/**
 * @function 删除文件
 * @param {object?} data 上传参数
 * @param {object?} config 配置参数
 * @returns
 */
export const fileDeleteV2 = (data = {}, config = {}) => post(`${api2}/upload/del-file-v2`, data, config)
/**
 * 常用筛选
 */
// 校区筛选
export const get_school = () => get(`${api2}/common/screen/school`)
// 校区筛选2  联动
export const get_school2 = () => get(`${api1}/site/school`)
// 校区筛选3
export const get_school3 = () => get(`${api2}/question/common/schools`)
// 年级筛选
export const get_grade = () => get(`${api2}/common/screen/grade`)
// 年级筛选2 联动
export const get_grade2 = () => get(`${api1}/site/grades`)
// 年级筛选3
export const get_grade3 = () => get(`${api2}/question/common/grades`)
// 全部年级
export const get_grade_all = () => get(`${api2}/common/screen/grade-all`)
// 招生年级
export const get_grade_zs = () => get(`${zs}/recruit/common/grade`)
// 行政班
export const get_class = data => get(`${api2}/common/screen/admin-class`, data)
// 行政班 筛选2 联动
export const get_class2 = data => get(`${api1}/site/role-admin-class`, data)
// 角色类型
export const get_role = () => get(`${api2}/common/screen/role-type`)
// 专业方向/学习方向
export const get_major = () => get(`${api2}/common/screen/major`)


/**
 * 系统使用优化迭代
 * 设置 校区基础信息管理 学生账号管理
 * 教务 教务信息管理 学生管理
 * 个人信息 设置 账号设置
 * 其他 CMD
 */
// 获取token
export const system_getToken = data => post(`/api4/get_token`, data)
// 教师工作助手解邦
export const system_unbinding = data => put(`/api4/account_data/unbinding`, data)
// 重置密码
export const system_reset_pwd = data => put(`/api4/account_data/reset_pwd`, data)
// 修改账户
export const system_account_change = data => post(`${api2}/account-student/teacher/change-account`, data)
// 开发人员的mysql,redis指令工具
export const system_cmd = data => post(`${api2}/tool/dev-tool/cmd`, data)
// 操作记录列表
export const system_history = data => get(`/api4/opt_history/list`, data)


/**
 * 艺体生转入转出留痕及催缴
 * 一期 设置 校区基础信息管理 专业方向管理 选科组合管理
 */
const as_api = `${api2}/educational-routine/art/`
// 获取选科组合固定选项
export const as_combined = data => get(`${api2}/common/screen/combined`, data)
// 一期 专业方向管理
// 新增
export const as_major_add = data => post(`${as_api}major/store`, data)
// 编辑
export const as_major_edit = data => post(`${as_api}major/update`, data)
// 详情
export const as_major_show = data => get(`${as_api}major/show`, data)
// 选科组合管理
// 新增
export const as_subject_add = data => post(`${as_api}combined/store`, data)
// 编辑
export const as_subject_edit = data => post(`${as_api}combined/update`, data)
// 详情
export const as_subject_show = data => get(`${as_api}combined/show`, data)


/**
 * 艺体生转入转出留痕及催缴
 * 二期 教务 艺体生业务  财务 艺体生缴费 教务 教务信息管理 学生管理
 */
const as2_api = `${api2}/educational-routine/art`
// 列表搜索行政班
export const as2_search_class = data => get(`${as2_api}/apply/search-class`, data)
// 搜索学生
export const as2_search_student = data => get(`${as2_api}/apply/search-student`, data)
// 获取学生信息
export const as2_get_student = data => get(`${as2_api}/apply/get-student`, data)
// 获取班级下的班主任
export const as2_get_class_teacher = data => get(`${api2}/common/screen/class-teacher`, data)
// 搜索教师
export const as2_search_teacher = data => get(`${as2_api}/apply/search-teacher`, data)
// 联动科目组合
export const as2_combined_list = data => get(`${as2_api}/combined/linkage`, data)
// 获取联动专业方向
export const as2_major_list = data => get(`${as2_api}/major/linkage`, data)

// 转入转出申请详情
export const as2_apply_show = data => get(`${as2_api}/apply/show`, data)
// 检测教学班是否存在冲突
export const as2_apply_check = data => post(`${as2_api}/apply/check-teaching`, data)
// 转入转出申请新增
export const as2_apply_store = data => post(`${as2_api}/apply/store`, data)
// 转入收款进度详情
export const as2_collect_show = data => get(`${as2_api}/collect/show`, data)
// 艺体生转入缴费记录详情
export const as2_pay_show = data => get(`${as2_api}/pay/show`, data)
// 艺体生转入缴费记录编辑
export const as2_pay_update = data => post(`${as2_api}/pay/update`, data)
// 获取缴费记录
export const as2_pay_record = data => get(`${as2_api}/pay/record`, data)
// 获取操作日志记录
export const as2_pay_history = data => get(`${api2}/educational-routine/public/opt-history`, data)

// 艺体转入/转出记录
export const as2_art_record = data => get(`${api2}/student/details/art-record`, data)

/**
 * 2024招生线上报名v1.0 - 配置功能
 * 招生 设置 2024容缺人员 2024中考配置 2024针诊断性考试科目 2024诊断性考试管理 2024学校录取分数线
 */
// 2024招生 获取省市区 is_level=1 获取地址层级结构   address_type  级别，1：省级，2：市，3：区
export const get_2024area = data => zsGet('/recruit-2024/exam/get-city-code', data)
// 2024招生 获取省市区
export const get_2024government = data => zsGet('/recruit-2024/exam/get-city-code', data)
// 2024招生 学科
export const get_2024subject = () => zsGet('/recruit-v2/common/get-subject')
// 2024招生 学校
export const get_2024schools = () => zsGet('/recruit/common/schools')

// 2025招生 获取套餐类型
export const get_2025pack = () => new Promise((resolve, reject) => {
  zsGet('/recruit/account-manage/get-pack-type').then(res => {
    if (!res) return resolve([])
    const list = res.map(item => ({ label: item.name, value: item.type }))
    resolve(list)
  }).catch(err => reject(err))
})


/**
 * 2024招生线上报名v1.8
 * 招生 客户管理 应接受报名
 */
// 查询招生教师   [status] 教师状态，0：禁用，1：启用 [name] 学习方向
export const get_recruit_teacher = data => zsGet('/recruit/common/get-recruit-teacher', data)
export const get_recruit_teacher_ = (data) => zsGet("/recruit/fresh-graduate/search-diy-teacher", data);
// 应届生报名订单总数
export const get_recruit_count = data => zsGet('/recruit/fresh-graduate/count', data)
// 应届生报名订单总数
export const get_recruit_count_ = (data) => zsGet("/recruit/fresh-graduate/count", data);
// 修改应届生报名订单当前客户归属人
/**
 * @function 修改应届生报名订单当前客户归属人
 * @param {object} data 请求参数
 * @param {object} config 配置参数，可通过timeout: 0取消超时
 * @returns {Promise}
 */
export const edit_belong_teacher = (data, config = {}) => zsPost('/recruit/fresh-graduate/chg-belong-teacher', data, config)


/**
 * 鸿鹄智慧教育平台 - 基础配置
 */

/**
 * 操作记录列表(api2)
 * @param {object} data           请求参数
 * @param {string} data.tbl_name  类型
 * @param {string} data.tbl_id    id
 * @param {number} data.size      [20]每页条数
 * @returns
 */
export const get_history = data => get(`${api2}/common/public/get-opt-history`, data)


/**
 * @function 历史操作记录（招生）
 * @param {object} data 请求参数
 * @param {BaseInterface['zs_history_type']} data.type 类型 [商品管理, 商品规格管理, 商品套餐管理, 员工账号管理, 中考考试科目管理, 学校目录管理, 中考科目管理, 中考普高控制线, 预报名线索池, 应届生报名编辑, 本校直升人员, 中考分数配置]
 * @param {number} data.id id值
 * @param {number} [data.page] 查询页数
 * @param {number} [data.page_size] 每页条数
 * @returns {Promise<*[]>}
 */
export const zs_opt_history = data => {
  const { page = 1, page_size = 20, type, id } = data
  const params = { page, page_size, tbl_name: type, tbl_id: id }
  return zsGet('/recruit/common/get-opt-history', params)
}

/**
 * @function 历史操作记录（智慧教育）
 * @param {object} data 请求参数
 * @param {BaseInterface['zh_history_type']} data.type 类型 [教材版本,章节管理,知识点管理,分类管理,商品管理, 商品规格管理, 商品套餐管理, 员工账号管理, 中考考试科目管理, 学校目录管理, 中考科目管理, 中考普高控制线, 预报名线索池, 应届生报名编辑, 本校直升人员, 中考分数配置]
 * @param {number} data.id id值
 * @param {number} [data.page] 查询页数
 * @param {number} [data.page_size] 每页条数
 * @returns {Promise<*[]>}
 */
export const zh_opt_history = data => {
  const { page = 1, page_size = 20, type, id } = data
  const params = { page, page_size, tbl_name: type, tbl_id: id }
  return zhGet('/get-opt-history', params)
}

/**
 * @function 获取学段列表
 * @returns {Promise<*[]>}
 */
export const zh_grade_year = () => new Promise((resolve, reject) => {
  zhGet('/video/grade-year').then(res => {
    if (!res) return resolve([])
    const list = Object.keys(res).map(key=>{
      const { grade, id, years } = res[key]
      return { value: id, label: grade, children: changeObjToArr(years, true) }
    })
    resolve(list)
  }).catch(err => {
    reject(err)
  })
})

/**
 * @function 获取入学年份（2024开始）
 */
export const getEnrollmentYear = () => new Promise((resolve) => {
  const arr = [], start = 2024, end = new Date().getFullYear()
  for(let i = end; i >= start; i--) {
    arr.push({ label: i, value: i })
  }
  resolve(arr)
})

/**
 * @function 获取当前年份前后1年
 */
export const getAdjacentYears = () => new Promise((resolve) => {
  const arr = [], current = new Date().getFullYear()
  for(let i = current - 1; i <= current + 1; i++) {
    arr.push({ label: i, value: i })
  }
  resolve(arr)
})


/**
 * 2025招生正式报名一期
 * 招生 客户管理 应接受报名
 */

/**
 * 实际学校
 * @returns
 */
export const getActualSchool = (is_consulting) => new Promise((resolve, reject) => {
  const params = {}
  if (is_consulting !== undefined && is_consulting !== null) params.is_consulting = is_consulting
  baseApi({ url: '/recruit/common/school', pre: 'zs' }, params).then(res => {
    if (!res.entity_school) return resolve([])
    const list = res.entity_school.map(item => ({ label: item.school_name, value: item.id }))
    resolve(list)
  }).catch(err => reject(err))
})

/**
 * 所有年级
 */
export const getAllGrade = () => new Promise((resolve, reject) => {
  baseApi({ url: '/site/grades', pre: 'api1' }).then(res => {
    if (!res) return resolve([])
    const list = res.map(item => ({ label: item.name, value: item.id }))
    resolve(list)
  }).catch(err => reject(err))
})

/**
 * 所有未删除的年级
 */
export const getAllUnDeleteGrade = () => new Promise((resolve, reject) => {
  baseApi({ url: '/recruit/common/grade-all', pre: 'zs' }).then(res => {
    if (!res) return resolve([])
    const list = res.map(item => ({ label: item.name, value: item.id }))
    resolve(list)
  }).catch(err => reject(err))
})
/**
 * @function 招生V3字典
 * @returns {Promise<{ diff_fee: BaseInterface['option'][], order_type_pack_type: BaseInterface['option'][] }>}
 */
export const get_recruit_dict = () => new Promise((resolve, reject) => {
  zsGet('/recruit-v3/dict').then(res => {
    const list1 = changeOption({ list: res.diff_fee, label: 'name', value: 'id' })
    const list2 = changeOption({ list: res.order_type_pack_type, label: 'name', value: 'id' })
    const list3 = changeOption({ list: res.business_line, label: 'business_line_name', value: 'business_line' })
    const list4 = changeOption({ list: res.current_business_line_list, label: 'business_line_name', value: 'business_line' })
    const list5 = changeOption({ list: res.pack_type_list, label: 'name', value: 'id' })
    const list6 = changeOption({ list: res.repeat_business_line_list, label: 'business_line_name', value: 'business_line' })
    const list7 = changeOption({ list: res.student_type_add, label: 'student_type_name', value: 'student_type' })
    const list8 = changeOption({ list: res.approve_status_list, label: 'approve_status_name', value: 'approve_status' })
    const list9 = changeOption({ list: res.fill_in, label: 'fill_in_status_name', value: 'fill_in_status' })
    const list10 = changeOption({ list: res.goods_is_by_stages_list, label: 'is_by_stages_name', value: 'is_by_stages' })
    const list11 = changeOption({ list: res.order_is_by_stages_list, label: 'is_by_stages_name', value: 'is_by_stages' })
    const list12 = changeOption({ list: res.goods_stages_mode_list, label: 'stages_mode_name', value: 'stages_mode' })

    resolve({ diff_fee: list1, order_type_pack_type: list2, business_line: list3, current_business_line: list4, pack_type_list: list5, repeat_business_line: list6, student_type: list7, approve_status: list8, fill_in: list9, goods_stages_list: list10, order_stages_list: list11, stages_mode: list12 })
  }).catch(err => reject(err))
})

